import { useEffect } from 'react'
import client from 'api/client'
import { useRootStore } from 'stores/RootStore'

export type FlaggedFeature =
  | 'richtext_comments'
  | 'scheduled_reviews'
  | 'auto_reconnect_on_interval'
  | 'version_control_mode'
  | 'cable_debug_websocket'
  | 'anycable_tp_client'
  | 'dense_table'
  | 'turn_into_distribute'
  | 'new_inline_format_bar'
  | 'iframe_wrapper'
  | 'show_release_info'
  | 'skip_service_worker'
  | 'new_table_menu'
  | 'api_keys'
  | 'disable_gap_cursors'
  | 'black_friday_cta'
  | 'visual_studio'
  | 'usage_based_pricing'
  | 'blaze_academy'
  | 'scheduled_posts_v2'
  | 'mobile_ai_tools'
  | 'mobile_format_bar'
  | 'mobile_comments'
  | 'admin_templates'
  | 'revision_images'
  | 'recents_home_new'
  | 'more_elements'
  | 'templates_autoscaling'
  | 'mystic'
  | 'image_revisions'
  | 'tiktok_integration'
  | 'youtube_integration'
  | 'mobile_publishing'
  | 'writer_multiplanning'
  | 'brand_kits'
  | 'templates_page_v2'
  | 'product_tours_2025'
  | 'pro_trial'
  | 'annual_trial_discount'
  | 'video_wizards'
  | 'audience_metrics'
  | 'simplified_wizards'
  | 'mobile_redesign_wizard_A1'
  | 'mobile_redesign_wizard_A2'
  | 'mobile_redesign_wizard_B'
  | 'mobile_redesign_wizard_C'
  | 'mobile_redesign_wizard_D'
  | 'mobile_redesign_wizard_E'
  | 'mobile_redesign_wizard_F'
  | 'mobile_redesign_wizard_G'
  | 'mobile_redesign_wizard_H1'
  | 'mobile_redesign_wizard_I'
  | 'mobile_redesign_wizard_J'
  | 'mobile_redesign_wizard_K1'
  | 'mobile_redesign_wizard_M1'
  | 'saved_drafts'
  | 'blog_metadata_v2'
  | 'print_preview_v2'
  | 'superadmin_templates'
  | 'social_desktop_wizards_flow_A1'
  | 'social_desktop_wizards_flow_A2'
  | 'social_desktop_wizards_flow_B'
  | 'social_desktop_wizards_flow_C'
  | 'mobile_redesign_wizard_A1_layout_customisation'
  | 'new_registration'
  | 'integrations_banner'
  | 'instagram_captions_channel'
  | 'mobile_redesign_wizard_Z1'
  | 'stock_videos'
  | 'mobile_redesign_wizard_Z2'
  | 'desktop_wizards_updates'
  | 'ratings_extra_feedback'
  | 'geo_location_registration'
  | 'designer_resize'
  | 'brand_kit_migration'
  | 'wizards_tour'
  | 'new_desktop_image_gen'
  | 'mailchimp_integration'
  | 'go_high_level_integration'
  | 'wix_blog_integration'
  | 'shopify_integration'
  | 'april_sale'
  | 'brand_profile_playground'
  | 'gpt_image_one'
  | 'mobile_redesign_schematized_text_wizard'
  | 'new_image_menu'
  | 'post_preview_v2'
  | 'website_crawler'
  | 'templates_mix'
  | 'google_integration'
  | 'post_preview_v2_mobile'
  | 'image_menu_drawer'
  | 'virtual_marketer_upgrade'
  | 'designer_chat_assistant'
  | 'brand_kit_add_more_images'
  | 'vm_onboarding_add_more_images'
  | 'vm_onboarding_add_more_images_ai'
  | 'integrations_v3'
  | 'brand_profile_enhancement'
  | 'enhancement_preview'
  | 'calendar_full_screen_preview'
  | 'brand_kit_website_list_view'
  | 'vm_schedule_manually'
  | 'brand_kit_updates'
  | 'brand_kit_images_sorting'
  | 'ads_enabled'
  | 'copilot_native_layouts_instagram_posts'
  | 'copilot_native_layouts_instagram_stories'
  | 'copilot_native_layouts_linkedin_x_posts'
  | 'meta_ads_integration'
  | 'pyramid_strategy'
  | 'autopilot_early_bird'
  | 'ab_test_force_a'
  | 'ab_test_force_b'
  | 'autopilot_early_bird_9_26'
  | 'autopilot_early_bird_9_29'
  | 'cross_post_groups'
  | 'optimized_onboarding'
  | 'autopilot_registration_stale_client_modal'
  | 'change_strategy'
  | 'monotype_fonts'
  | 'multiple_accounts'
  | 'freemium_referrals'
  | 'scheduled_posts_v3'
  | 'use_scheduled_posts_for_mailchimp'
  | 'autopilot_mobile_onboarding'
  | 'blog_platform_onboarding_branding'
  | 'external_integrations_heartbeat'
  | 'onboarding_no_website_flow'
  | 'calendar_target_status'
  | 'video_autocrossposting'
  | 'generation_credits'
  | 'ad_wizard_creative_recycling'
  | 'brain_playground'
  | 'use_native_property_columns'
  | 'brand_kit_media_reservation'
  | 'campaigns_launch'
  | 'animated_image_generation'
  | 'native_brand_kit_brand_profile'
  | 'native_brand_kit_content_preferences'
  | 'native_brand_kit_images_videos'
  | 'native_brand_kit_source_materials'
  | 'native_brand_kit_styles_voice'
  | 'post_approvals'
  | 'approvals_page'
  | 'system_redesign'
  | 'onboarding_redesign'
  | 'onboarding_plan_choice'
  | 'create_campaigns_workspace'
  | 'brain_channel_insights'
  | 'visual_styles_playground'
  | 'audio_editor_modal'
  | 'settings_modal_update'
  | 'brain_strategic_recommendations_debug'
  | 'ap_mobile_web_calendar'
  | 'ap_mobile_web_calendar_swipe'
  | 'metrics_improvements'
  | 'white_label'
  | 'youtube_metrics'
  | 'brain_homepage'
  | 'ap_mobile_web_content_preview'
  | 'ap_mobile_web_regenerate'
  | 'visual_styles'
  | 'visual_styles_existing_users'
  | 'visual_styles_onboarding'
  | 'load_monotype_fonts'
  | 'ap_mobile_web_crosspost'
  | 'content_preferences_redesign'
  | 'ap_mobile_home'
  | 'batch_campaign_regeneration'
  | 'pioneer_credits'
  | 'calendar_refetch_pending_schedules'

export const ActiveFlags: FlaggedFeature[] = [
  'richtext_comments',
  'scheduled_reviews',
  'auto_reconnect_on_interval',
  'version_control_mode',
  'anycable_tp_client',
  'cable_debug_websocket',
  'show_release_info',
  'api_keys',
  'disable_gap_cursors',
  'visual_studio',
  'blaze_academy',
  'scheduled_posts_v2',
  'mobile_ai_tools',
  'mobile_format_bar',
  'mobile_comments',
  'admin_templates',
  'revision_images',
  'recents_home_new',
  'more_elements',
  'templates_autoscaling',
  'mystic',
  'image_revisions',
  'tiktok_integration',
  'youtube_integration',
  'mobile_publishing',
  'writer_multiplanning',
  'brand_kits',
  'templates_page_v2',
  'product_tours_2025',
  'pro_trial',
  'annual_trial_discount',
  'video_wizards',
  'audience_metrics',
  'simplified_wizards',
  'mobile_redesign_wizard_A1',
  'mobile_redesign_wizard_A2',
  'mobile_redesign_wizard_B',
  'mobile_redesign_wizard_C',
  'mobile_redesign_wizard_D',
  'mobile_redesign_wizard_E',
  'mobile_redesign_wizard_F',
  'mobile_redesign_wizard_G',
  'mobile_redesign_wizard_H1',
  'mobile_redesign_wizard_I',
  'mobile_redesign_wizard_J',
  'mobile_redesign_wizard_K1',
  'mobile_redesign_wizard_M1',
  'saved_drafts',
  'blog_metadata_v2',
  'print_preview_v2',
  'social_desktop_wizards_flow_A1',
  'social_desktop_wizards_flow_A2',
  'social_desktop_wizards_flow_B',
  'social_desktop_wizards_flow_C',
  'stock_videos',
  'mobile_redesign_wizard_A1_layout_customisation',
  'new_registration',
  'instagram_captions_channel',
  'mobile_redesign_wizard_Z1',
  'mobile_redesign_wizard_Z2',
  'desktop_wizards_updates',
  'ratings_extra_feedback',
  'geo_location_registration',
  'designer_resize',
  'brand_kit_migration',
  'wizards_tour',
  'new_desktop_image_gen',
  'mailchimp_integration',
  'april_sale',
  'brand_profile_playground',
  'gpt_image_one',
  'mobile_redesign_schematized_text_wizard',
  'new_image_menu',
  'post_preview_v2',
  'website_crawler',
  'templates_mix',
  'google_integration',
  'post_preview_v2_mobile',
  'image_menu_drawer',
  'virtual_marketer_upgrade',
  'designer_chat_assistant',
  'brand_kit_add_more_images',
  'vm_onboarding_add_more_images',
  'vm_onboarding_add_more_images_ai',
  'integrations_v3',
  'brand_profile_enhancement',
  'enhancement_preview',
  'calendar_full_screen_preview',
  'brand_kit_website_list_view',
  'vm_schedule_manually',
  'brand_kit_updates',
  'brand_kit_images_sorting',
  'ads_enabled',
  'copilot_native_layouts_instagram_posts',
  'copilot_native_layouts_instagram_stories',
  'copilot_native_layouts_linkedin_x_posts',
  'meta_ads_integration',
  'go_high_level_integration',
  'wix_blog_integration',
  'pyramid_strategy',
  'autopilot_early_bird',
  'ab_test_force_a',
  'ab_test_force_b',
  'autopilot_early_bird_9_26',
  'autopilot_early_bird_9_29',
  'cross_post_groups',
  'optimized_onboarding',
  'autopilot_registration_stale_client_modal',
  'monotype_fonts',
  'multiple_accounts',
  'freemium_referrals',
  'scheduled_posts_v3',
  'use_scheduled_posts_for_mailchimp',
  'autopilot_mobile_onboarding',
  'blog_platform_onboarding_branding',
  'external_integrations_heartbeat',
  'onboarding_no_website_flow',
  'calendar_target_status',
  'video_autocrossposting',
  'generation_credits',
  'ad_wizard_creative_recycling',
  'use_native_property_columns',
  'brand_kit_media_reservation',
  'campaigns_launch',
  'animated_image_generation',
  'native_brand_kit_brand_profile',
  'native_brand_kit_content_preferences',
  'native_brand_kit_images_videos',
  'native_brand_kit_source_materials',
  'native_brand_kit_styles_voice',
  'post_approvals',
  'approvals_page',
  'system_redesign',
  'onboarding_redesign',
  'onboarding_plan_choice',
  'create_campaigns_workspace',
  'brain_channel_insights',
  'visual_styles_playground',
  'audio_editor_modal',
  'settings_modal_update',
  'brain_strategic_recommendations_debug',
  'ap_mobile_web_calendar',
  'ap_mobile_web_calendar_swipe',
  'metrics_improvements',
  'white_label',
  'youtube_metrics',
  'brain_homepage',
  'ap_mobile_web_content_preview',
  'ap_mobile_web_regenerate',
  'visual_styles',
  'visual_styles_existing_users',
  'visual_styles_onboarding',
  'load_monotype_fonts',
  'ap_mobile_web_crosspost',
  'content_preferences_redesign',
  'ap_mobile_home',
  'batch_campaign_regeneration',
  'pioneer_credits',
  'calendar_refetch_pending_schedules',
]

export interface FlipperOverride {
  [key: string]: boolean
}

/**
 * Returns whether the feature is enabled. Takes user-specific (localStorage) overrides and URL query overrides into account.
 * @returns boolean
 */
export const useFlipperFlag = (feature: FlaggedFeature, logImpression: boolean = false) => {
  const rootStore = useRootStore()
  const featureFlags = rootStore.featureFlags

  useEffect(() => {
    if (!logImpression) return

    // Create user_experiment record
    client.createUserExperimentImpression(feature)
  }, [logImpression, feature])

  return featureFlags.isActive(feature)
}
